export default function contactToggle() {
    const btn = document.getElementById('waBtn');
    const waContainer = document.getElementById('waContainer');
    const waContent = document.getElementById('waContent');

    btn.addEventListener('click', () => {
        btn.classList.toggle('-translate-y-[4.5rem]');
        waContent.classList.toggle('opacity-0');
        waContent.classList.toggle('pointer-events-auto');
        waContainer.classList.toggle('translate-y-16');
    });
}
